import yup from '../../../config/yup';

export const amazonRDSWriterFormSchema = yup.object().shape({
  '@id': yup.string(),
  name: yup
    .string()
    .matches(/^[a-zA-Z_$][a-zA-Z0-9_$]*$/, {
      message:
        'Name must start with a letter or underscore and can only contain letters, numbers, and underscores',
    })
    .required('Name is required'),
  type: yup.string().default('amazonRDSWriter'),
  delayedRead: yup.boolean(),
  onError: yup.string(),
  connectionKey: yup.string(),
  properties: yup.object().shape({
    databaseType: yup
      .string()
      .matches(/^(PostgreSQL|MySQL|\{\{env\.vars\.[a-zA-Z0-9_]+\}\})$/, {
        message:
          'Database type must be PostgreSQL, MySQL or an environment variable pattern {{env.vars.*}}',
      })
      .required('Database type is required')
      .default('PostgreSQL'),
    databaseName: yup
      .string()
      .required('Database name is required')
      .transform((value) => value.trim()),
    username: yup.string().transform((value) => value?.trim()),
    password: yup.string().transform((value) => value?.trim()),
    instanceConnectionName: yup.string().transform((value) => value?.trim()),
    // JDBC properties
    tableName: yup.string().required('Table name is required'),
    driver: yup.string().required('Driver is required'),
    host: yup.string(),
    port: yup.number().typeError('Port must be a number'),
  }),
});
